/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return FeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<FeatureFlagsWithDefaults>): FeatureFlagsWithDefaults {
        let obj = Object.assign(new FeatureFlagsWithDefaults(), model);
        FeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FeatureFlagsWithDefaults>): FeatureFlagsWithDefaults {
        if (!model) return null;
        return FeatureFlagsWithDefaults.newInstance(<FeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FeatureFlagsWithDefaults) {
        if (!obj) return;

        models.FeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FeatureFlagsWithDefaults): boolean {
        Object.setPrototypeOf(obj, FeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

}
